/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const OrientationLandscapeIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Orientation Landscape',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M10,11.06445c-1.5127,0-2.74414-1.2334-2.74414-2.75s1.23145-2.75,2.74414-2.75,2.74414,1.2334,2.74414,2.75-1.23145,2.75-2.74414,2.75ZM10,7.06445c-.68555,0-1.24414.56055-1.24414,1.25s.55859,1.25,1.24414,1.25,1.24414-.56055,1.24414-1.25-.55859-1.25-1.24414-1.25Z"
      fill="currentColor"
    />
    <path
      d="M16.75,3H3.25c-1.24023,0-2.25,1.00977-2.25,2.25v9.5c0,1.24023,1.00977,2.25,2.25,2.25h13.5c1.24023,0,2.25-1.00977,2.25-2.25V5.25c0-1.24023-1.00977-2.25-2.25-2.25ZM7.41333,15.5c.07715-.79395.31274-1.58325.9021-1.9248,1.08398.42188,2.29199.42285,3.37207-.00098.56982.3501.79102,1.18848.87158,1.92578h-5.14575ZM17.5,14.75c0,.41309-.33691.75-.75.75h-2.69434c-.20435-2.30396-1.24121-3.16333-2.12598-3.45703-.18555-.06152-.38477-.0498-.55957.03516-.87012.41602-1.8623.41699-2.73535.00293-.1748-.08203-.37109-.09473-.55664-.03418-1.26221.4165-2.01587,1.63232-2.16675,3.45312h-2.66138c-.41309,0-.75-.33691-.75-.75V5.25c0-.41309.33691-.75.75-.75h13.5c.41309,0,.75.33691.75.75v9.5Z"
      fill="currentColor"
    />
  </svg>`;
};
